// DESIGN SYSTEM 2025 //
// CORES GRAFICOS
/**
 * Sugestões de aplicação:
 * Gráfico de Linhas: Azul profundo, azul ciano, verde investimentos e roxo
 * Gráficos de Barra: Usar sequência da paleta (1 a 6)
 * Gráfico de Pizza: Máximo 6 cores diferentes
 * Radar/Spider: Azul, laranja, verde e roxo
 */
export const coresAlternativas = [
  '#BEB4AB',
  '#BFCACB',
  '#AF9692',
  '#E0904A',
  '#BDA767',
]
export const coresGraficoLinha = ['#1A2E66', '#00A6DE', '#3BA272', '#6c4f9b']
export const coresNomes = {
  azulProfundo: '#1a2e66',
  azulRoyal: '#245ca6',
  azulCiano: '#00a6de', // Para contraste
  verdeInvestimento: '#3ba272',
  laranjaDinamico: '#f5a623',
  vermelhoControle: '#d9534f',
  dourado: '#c19a42',
  cinza: '#a8a8a8',
  cinzaEscuro: '#4F4F4F',
  cinzaMedio: '#767676', // entre cinzaEscuro (#4F4F4F) e cinza (#a8a8a8)
  roxo: '#6c4f9b',
  azulPetroleo: '#006d77',
  verdeNeutro: '#b7c9a3',
}
export const _paleta = [
  coresNomes.verdeInvestimento,
  coresNomes.dourado,
  coresNomes.cinza,
  coresNomes.roxo,
  coresNomes.azulPetroleo,
  coresNomes.verdeNeutro,
  ...coresAlternativas,
]

// DESIGN SYSTEM 2025 //

export const paleta = [
  '#54AA76',
  '#38D600',
  '#0C7A7A',
  '#0038FF',
  '#B942F1',
  '#1BD4D4',
  '#664EFF',
  '#FF8A00',
  '#E0AF00',
  '#13B8FF',
  '#2B00A4',
  '#FF36EB',
  '#FF8BA7',
  '#976D00',
  '#83A400',
  '#BC88FF',
  '#374459',
  '#2E86AB',
  '#6E1100',
  '#E75735',
  '#986F4B',
  '#2FB89F',
  '#645E9D',
  '#7FB97F',
  '#F6E89F',
  '#644D40',
  '#2D6727',
  '#FF8F00',
  '#6C757D',
  '#65CB3B',
  '#FFBB00',
  '#AAABE2',
  '#F29741',
  '#54AA76',
  '#38D600',
  '#0C7A7A',
  '#0038FF',
  '#B942F1',
  '#1BD4D4',
  '#664EFF',
  '#FF8A00',
  '#E0AF00',
  '#13B8FF',
  '#2B00A4',
  '#FF36EB',
  '#FF8BA7',
  '#976D00',
  '#83A400',
  '#BC88FF',
]

export const colors = [
  '#60be7b',
  '#34804c',
  '#296ab4',
  '#124a88',
  '#807f7f',
  '#545454',
  '#010101',
  '#6f3996',
]

export const segments = {
  varejo: '#5B9BD5',
  altaRenda: '#5EBE7B',
  private: '#7F7F7F',
}

export const BENCHMARKS_COLORS = {
  CDI: '#2D212F',
  'IPC-A': '#FF5722',
  'IMA-B': '#388E3C',
  IBOVESPA: '#FFA000',
  IFIX: '#644D40',
  'IRF-M': '#AAABE2',
  DÓLAR: '#2E86AB',
  'S&P 500': '#004D40',
  CPI: '#8E24AA',
}

// Cor institucional AAWZ ouro para o benchmark personalizado do cliente
export const BENCHMARK_PERSONALIZADO_COLOR = '#C9A961'

export const LIQUIDITY_TAG_COLORS = [
  '#54AA7633',
  '#38D60033',
  '#0038FF33',
  '#B942F133',
]

export const light_mode = {
  white: '#FFFFFF',
  black: '#030309',
  green: '#56AF79',
  'green-light': '#C8E6C9',
  'green-dark': '#368B57',
  red: '#FF5252',
  redDarker: '#D50000',
  'red-light': '#FFCDD2',
  yellow: '#FFD500',
  'yellow-light': '#FFF9C4',
  'yellow-dark': '#BA9309',
  blue: '#3242B9',
  'gray-1': '#F0F1F5',
  'gray-2': '#F1EFF2',
  'gray-3': '#E4E0E6',
  'gray-4': '#C7BBC9',
  'gray-5': '#A79CAC',
  'gray-6': '#87798D',
  'gray-7': '#38303B',
  'gray-8': '#2D212F',
  primary: '#56AF79',
  // secondary: '#C7BBC9',
  secondary: '#8e8e8e',
  success: '#6FCF97',
  danger: '#EB5757',
  light: '#F0F1F5',
  dark: '#2D212F',
  warning: '#FFD500',
}

export const donutChartColors = [
  '#247ED1',
  '#509EDF',
  '#56AF79',
  '#689734',
  '#6E7280',
  '#9499AB',
  '#A78CC3',
  '#8A5EB0',
  '#B66A67',
  '#EE8E8A',
]

export const commissionsChartColor = {
  revenue: donutChartColors[2],
  commission: '#56AF79', // donutChartColors[3],
  guaranteedMinimum: donutChartColors[1],
}

export const revenueChartColors = {
  'Receita Líquida': donutChartColors[2],
  Repasse: light_mode['green-light'],
  'Repasse para o Escritório': light_mode.primary,
  Imposto: donutChartColors[4],
}

// Paleta dos KPIs da página Financeiro > Profissional (ordem: Faturamento por
// tamanho da equipe, Faturamento por tamanho da equipe comercial, Tamanho da
// equipe, Tamanho da equipe comercial).
export const PROFESSIONAL_CHART_PALETTE = [
  '#56AF79',
  '#03AADF',
  '#B223E4',
  '#EE75CC',
]

export default {
  segments,
  paleta,
  light_mode,
  colors,
  donutChartColors,
  revenueChartColors,
  commissionsChartColor,
  BENCHMARKS_COLORS,
}

export const billsToPayStatus = {
  'incluida-erp': '#50C878',
  'fatura-pendente': '#FFBB00',
  'nota-fiscal-pendente': '#FF8A00',
  'aguardando-terceiros': '#FF2401',
  'aguardando-remessa': '#ECDB00',
  'pagamento-agendado': '#7F01E2',
  'pagamento-aprovado': '#ad01c1',
  'pagamento-conciliado': '#20B2AA',
}

export const billsToReceiveStatus = {
  'Verificar leitura dos dados': '#19B4C6',
  'Pendente faturamento': '#E85CFF',
  'Gerando nota fiscal': '#8C0CDB',
  'A receber': '#FF8A00',
  'Pedido de cancelamento': '#EB5757',
  Recebido: '#56AF79',
  'Solicitação cancelada': '#7C89B7',
  'Nota cancelada': '#7C89B7',
}
